const root = {
  "default-theme": "light",
  "default-sidebar": "right"
};
const code = {
  "default-scheme": "highlight",
  "default-verbose": false,
  "default-indent-spaces": 2
};
const renderer = {
  "default-positioning": "center",
  "default-background": "white"
};
const defaultSettings = {
  root,
  code,
  renderer
};
export {
  code,
  defaultSettings as default,
  renderer,
  root
};
//# sourceMappingURL=settings.json.js.map
